import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqs = [
  { question: 'What is the UEA Trading Robot?', answer: 'The UEA Trading Robot is an advanced algorithmic trading software designed to automate forex trading decisions. It uses sophisticated AI algorithms and real-time market analysis to maximize profits and minimize risk.' },
  { question: 'How does the UEA Trading Robot work?', answer: 'The Robot analyzes market trends, candlestick patterns, pivot points, and price action to execute trades automatically 24/7, following your predefined risk management strategies.' },
  { question: 'Do I need prior trading experience?', answer: 'No experience needed. UEA Trading Robot is designed to be plug-and-play for beginners while offering advanced customization for experienced traders. Full setup support is provided.' },
  { question: 'Can I use it to pass prop firm challenges?', answer: 'Absolutely! UEA Trading Robot has successfully passed FTMO, Tiger Funded, E8, and many other major prop firm challenges. It has built-in equity protection for challenge compliance.' },
  { question: 'Which platforms are supported?', answer: 'UEA supports MT4, MT5, TradeLocker, cTrader, DXTrade, and MatchTrader. Each platform has optimized set files for maximum performance.' },
  { question: 'Is my investment secure with UEA Robot?', answer: 'UEA employs advanced risk management with maximum 3-5% drawdown. It does not use martingale or hedging strategies. However, all trading carries inherent market risk.' },
];

function FAQItem({ question, answer, index }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.07 }}
      className="rounded-xl border overflow-hidden"
      style={{ borderColor: isOpen ? "rgba(34,197,94,0.3)" : "rgba(59,130,246,0.1)", background: "var(--uea-card)" }}
    >
      <button
        className="w-full flex justify-between items-center px-6 py-5 text-left"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-white font-semibold text-sm pr-4 font-exo">{question}</span>
        <motion.span
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-sm"
          style={{ background: isOpen ? "rgba(34,197,94,0.2)" : "rgba(59,130,246,0.1)", color: isOpen ? "#22c55e" : "#3b82f6" }}
        >
          {isOpen ? <FaMinus className="text-xs" /> : <FaPlus className="text-xs" />}
        </motion.span>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="px-6 pb-5 text-slate-400 text-sm leading-relaxed border-t" style={{ borderColor: "rgba(34,197,94,0.1)" }}>
              <p className="pt-4">{answer}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default function FAQSection() {
  return (
    <section id="faq" className="py-24 px-6" style={{ background: "var(--uea-black)" }}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-xs font-mono-code text-green-400 tracking-widest uppercase">// FAQ</span>
          <h2 className="font-orbitron font-black text-3xl sm:text-4xl text-white mt-4">
            Frequently Asked{" "}
            <span style={{ background: "linear-gradient(135deg, #22c55e, #3b82f6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
              Questions
            </span>
          </h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <FAQItem key={i} index={i} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}
